module.exports = __webpack_public_path__ + "assets/icons/ic_keyboard_arrow_up-8654.svg";